// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"4121":"vendor","8792":"main"}[chunkId] + "." + {"4121":"045d2807b9dcfa83c976","8792":"52fcbfeddb88ccf3de25"}[chunkId] + ".css";
};